<template>
  <div class="select-product">
    <h3 class="choose-product-title">{{ letter.selectMoney }}</h3>
    <!-- 2022-02-23 新增第三方支付商品搜素功能-->
    <div class="search-wrap" v-show="productList.length || searchVal">
      <Select
        type="selectProductOrder"
        icon="selectvh"
        rightSpan="1.2vh"
        class="select-search-type"
        v-model="curSearchType"
        style="width: 18vh"
      >
        <option
          v-for="item in searchType"
          :key="item.value"
          :value="item.value"
        >
          {{ item.name }}
        </option>
      </Select>
      <input
        :placeholder="searchPlaceholder[curSearchType]"
        class="search-input"
        v-model.trim="searchVal"
        type="search"
      />
    </div>

    <Select
      type="selectProductOrder"
      icon="selectvh"
      rightSpan="1.2vh"
      class="select-product-order"
      pointClass="j-select-order"
      v-model="curOrderType"
      @change="updateOrderType"
      v-show="productList.length"
    >
      <option v-for="item in orderList" :key="item.value" :value="item.value">
        {{ item.name }}
      </option>
    </Select>
    <Block
      type="productTypeSelect"
      class="product-type-select"
      v-show="productList.length && productType.length > 1"
    >
      <template v-for="item in productType">
        <BlockClickable
          :type="
            curProductType == item.value
              ? 'productTypeSelectItemCur'
              : 'productTypeSelectItem'
          "
          class="product-type-select-item"
          :pointValue="item.value"
          :pointClass="`j-select-product-type`"
          :class="{ cur: curProductType == item.value }"
          :key="item.value"
          @click="updateProductType(item.value)"
          >{{ item.name }}
        </BlockClickable>
      </template>
    </Block>
    <p class="uid-tips" v-if="uidGame">{{ letter.webStoreUidTips }}</p>
    <p class="search-tips" v-if="!productList.length && searchVal">
      {{ letter.search_no_found }}
    </p>
    <div class="swtwt-tip" v-if="showSwtwtTip">
      <p v-for="(item, key) in swtwtTip" :key="key">{{ item }}</p>
    </div>
    <div>
      <div class="load" v-if="showLoading">
        <i class="loading load1"></i>
        <i class="loading load2"></i>
        <i class="loading load3"></i>
      </div>
      <div
        v-for="(boxItem, index) in productList"
        class="game-box"
        :key="index"
      >
        <template v-for="(item, indexItem) in boxItem">
          <BlockClickable
            type="productItem"
            class="product-item"
            :data-productid="item.PRODUCT_ID"
            :pointClass="'j-select-product'"
            :class="[
              item.empty ? 'not-select' : false,
              item.IS_CURRENCY ? 'currency' : false
            ]"
            @click="
              selectProduct(
                item.PRODUCT_ID,
                item.CP_PRODUCT_ID,
                item.REMARK,
                item.PRODUCT_TYPE,
                item.empty,
                item.IS_CURRENCY
              )
            "
            :key="indexItem"
          >
            <div>
              <span class="product-tag" v-if="item.PRODUCT_TAG">
                {{
                  letter[`store_tag_${item.PRODUCT_TAG.toLocaleLowerCase()}`] ||
                  item.PRODUCT_TAG
                }}
              </span>
              <!-- <span class="product-tag">首冲双倍</span> -->
              <img
                class="img product-icon"
                v-if="item.PRODUCT_ICON"
                :src="item.PRODUCT_ICON"
              />
              <img
                class="img product-icon"
                v-else
                :src="getProductDefaultIcon(item.PRODUCT_TYPE)"
              />
            </div>
            <p class="product-name name">
              {{ getProductName(item) }}
            </p>
            <p class="product-extra name" v-if="item.PRODUCT_EXTRA_DESC">
              {{ item.PRODUCT_EXTRA_DESC }}
            </p>
            <p class="coupon-tag" v-if="+item.COUPON === 1">
              <span class="coupon-tag-text">{{ letter.couponCanUseQuan }}</span>
            </p>
            <Block class="product-price" type="productItemPrice">
              <!-- 代金币商品不显示金额，直接显示文案（写在了GAME_AMOUNT字段） -->
              <span class="bi" v-show="!item.IS_CURRENCY">{{ currency }}</span>
              <span class="price" :class="{ s: item.IS_CURRENCY }">{{
                item.GAME_AMOUNT
              }}</span>
            </Block>
          </BlockClickable>
        </template>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
// import {UPDATE_GAMEID} from "../../store/web/webStore";
import { getProductDefaultImg } from '../../utiles/productImg';
import { deviceDirectionPortrait } from '../../utiles/device';
import { commonEmitUpload } from '../../plugins/AnalyzePoint';
import globalConfig from '../../utiles/globalConfig';
import { insertCurrency } from '../../store/config/currencyEnter';
import product from '@mixins/product';
import { getGlobalGetLinkParams } from '@utiles/globalGetLink';
const mainHost = globalConfig.getMainHost();
const isFromIframe = globalConfig.getHrefParam('fromIframe') || '';
const pageSource = globalConfig.getHrefParam('pageSource') || '';

const PACKAGE_TAG_LIST = [
  'hot',
  'discount',
  'double',
  'treble',
  'sale',
  'top_seller',
  'off_10',
  'off_20',
  'off_30',
  'off_40',
  'off_50',
  'off_60',
  'off_70',
  'off_80',
  'off_90',
  'event',
  'daily',
  'weekly',
  'monthly'
];

const swtwtTipLangMap = {
  'zh-TW': [
    '1、富豪錢券價值：5新台幣≈1富豪錢券',
    '2、富豪錢券在購買後透過郵件發送到背包，可在遊戲內以代幣形式購買任意付費禮包和金條，消耗富豪錢券可以獲得等額VIP經驗喲~',
    '註：匯款管道贈送的金條會透過郵件發送到背包，其餘管道自動加算到餘額'
  ],
  'zh-CN': [
    '1、富豪钱券价值：5新台币≈1富豪钱券',
    '2、富豪钱券在购买后透过邮件发送到背包，可在游戏内以代币形式购买任意付费礼包和金条，消耗富豪钱券可以获得等额VIP经验哟~',
    '注：汇款渠道赠送的金条会透过邮件发送到背包，其余渠道自动加算到余额'
  ]
};

export default {
  name: 'webSelectProduct',
  mixins: [product],
  data() {
    return {
      uidGame: globalConfig.isUidGame(),
      preCount: 3,
      mainHost: globalConfig.getMainHost(),
      curOrderType: 'normal',
      curSearchType: 'name',
      curProductType: '',
      searchVal: ''
    };
  },
  mounted() {
    this.preCount = deviceDirectionPortrait() ? 2 : 3;

    if (window.onorientationchange) {
      window.addEventListener(
        'orientationchange',
        () => {
          this.preCount = deviceDirectionPortrait() ? 2 : 3;
        },
        false
      );
    } else {
      window.addEventListener(
        'resize',
        () => {
          this.preCount = deviceDirectionPortrait() ? 2 : 3;
        },
        false
      );
    }
  },
  computed: {
    // 时光商店商品类型为currency时显示的提示
    showSwtwtTip() {
      return (
        +this.gameId === 307 &&
        this.curProductType === 'currency' &&
        !this.showLoading
      );
    },
    swtwtTip() {
      const lang = this.$store.state.lang;
      return swtwtTipLangMap[lang]
        ? swtwtTipLangMap[lang]
        : swtwtTipLangMap['zh-TW'];
    },
    letter() {
      return this.$store.state.letter;
    },
    orderList() {
      return [
        { name: this.letter.orderNormal, value: 'normal' },
        { name: this.letter.orderPriceUp, value: 'priceUp' },
        { name: this.letter.orderPriceDown, value: 'priceDown' }
      ];
    },
    searchType() {
      return [
        { name: this.letter.product, value: 'name' },
        { name: this.letter.price, value: 'price' }
      ];
    },
    searchPlaceholder() {
      return {
        name: this.letter.search_product,
        price: this.letter.search_price
      };
    },
    productType() {
      const TYPES_NAME = {
        coin: this.letter.coinTypeName,
        package: this.letter.packageTypeName,
        subscription: this.letter.subscriptionTypeName,
        currency: this.letter.currencyTypeName
      };

      let res = [];
      if (this.$store.state.productTypes.length < 2) {
        this.curProductType = '';
        return res;
      }
      this.$store.state.productTypes.map(item => {
        if (item) {
          res.push({ name: TYPES_NAME[item], value: item });
        }
      });
      this.curProductType = res[0].value;
      return res;
    },
    // activeCouponId() {
    //   return this.$store.state.activeCouponId
    // },
    // activeCouponProductList() {
    //   return this.$store.getters.activeCouponProductList
    // },
    gameId() {
      return this.$store.state.gameId;
    },
    productTypes() {
      return this.$store.state.productTypes;
    },
    productList() {
      let _productList = [];

      let realProductList = [].concat(
        this.searchVal.length
          ? this.searchProductList
          : this.$store.state.productList
      );

      // if(this.activeCouponId) {
      //   realProductList = realProductList.filter(item => {
      //     if(this.checkInActiveCoupon(item.PRODUCT_ID,item.CP_PRODUCT_ID)) {
      //       return true
      //     }else{
      //       return false
      //     }
      //   })
      // }

      let isPackage =
        (!this.curProductType && this.$store.state.productTypes == 'package') ||
        this.curProductType == 'package';

      switch (this.curOrderType) {
        // 默认排序
        case 'normal': {
          let tagArr = [];
          let notagArr = [];
          // 先区分是否有tag
          realProductList.map(item => {
            // 只处理礼包的tag，非礼包的不处理
            if (isPackage) {
              if (item.PRODUCT_TAG) {
                // 插入的时候排一下序（tag权重）
                let orderIndex = tagArr.length - 1;
                let isAdd = false;
                while (~orderIndex) {
                  const preTagOrder = PACKAGE_TAG_LIST.indexOf(
                    tagArr[orderIndex].PRODUCT_TAG
                  );
                  const curTagOrder = PACKAGE_TAG_LIST.indexOf(
                    item.PRODUCT_TAG
                  );
                  if (preTagOrder >= curTagOrder) {
                    tagArr.splice(+orderIndex + 1, 0, item);
                    isAdd = true;
                    break;
                  } else {
                    orderIndex--;
                  }
                }
                if (!isAdd) {
                  tagArr.unshift(item);
                }
              } else {
                notagArr.push(item);
              }
            } else {
              notagArr.push(item);
            }
          });
          // 如果都没有tag，就可以结束了
          if (!tagArr.length) {
            _productList = notagArr;
            break;
          }
          _productList = tagArr.concat(notagArr);
          break;
        }
        // 价格升序
        case 'priceUp': {
          realProductList.sort((a, b) => {
            let bTagOrder = b.PRODUCT_TAG
              ? PACKAGE_TAG_LIST.indexOf(
                  String(b.PRODUCT_TAG).toLocaleLowerCase()
                )
              : -2;
            let aTagOrder = a.PRODUCT_TAG
              ? PACKAGE_TAG_LIST.indexOf(
                  String(a.PRODUCT_TAG).toLocaleLowerCase()
                )
              : -2;

            if (
              +b.GAME_AMOUNT > +a.GAME_AMOUNT ||
              (isPackage &&
                b.GAME_AMOUNT == a.GAME_AMOUNT &&
                bTagOrder < aTagOrder)
            ) {
              return -1;
            } else {
              return 1;
            }
          });

          _productList = realProductList;
          break;
        }
        // 价格降序
        case 'priceDown': {
          realProductList.sort((a, b) => {
            let bTagOrder = b.PRODUCT_TAG
              ? PACKAGE_TAG_LIST.indexOf(
                  String(b.PRODUCT_TAG).toLocaleLowerCase()
                )
              : -2;
            let aTagOrder = a.PRODUCT_TAG
              ? PACKAGE_TAG_LIST.indexOf(
                  String(a.PRODUCT_TAG).toLocaleLowerCase()
                )
              : -2;

            if (
              +b.GAME_AMOUNT < +a.GAME_AMOUNT ||
              (isPackage &&
                b.GAME_AMOUNT == a.GAME_AMOUNT &&
                bTagOrder < aTagOrder)
            ) {
              return -1;
            } else {
              return 1;
            }
          });

          _productList = realProductList;
          break;
        }
        default:
          break;
      }

      insertCurrency(
        _productList,
        this.$store.state.productList,
        this.gameId,
        this.currentLocation,
        this.productTypes
      );

      let res = [];
      let resI = 0;
      let i = this.preCount;

      for (let key in _productList) {
        // 分类过滤
        if (
          _productList[key].PRODUCT_TYPE != this.curProductType &&
          this.curProductType
        )
          continue;

        // 根据每行的个数推入
        if (i === this.preCount) {
          res.push([_productList[key]]);

          i--;
        } else {
          res[resI].push(_productList[key]);
          i--;
          if (i === 0) {
            resI += 1;
            i = this.preCount;
          }
        }
      }

      // 空元素补位
      if (res.length) {
        let lastLength = res[res.length - 1].length;
        if (lastLength < this.preCount) {
          let fixArr = new Array(this.preCount - lastLength).fill({
            empty: true
          });
          res[res.length - 1] = res[res.length - 1].concat(fixArr);
        }
      }
      return res;
    },
    showLoading() {
      return this.productList.length === 0 && this.$store.state.loadingProduct;
    },
    currency() {
      return this.$store.state.showCurrency;
    },
    currentLocation() {
      return this.$store.state.currentLocation;
    },
    searchProductList() {
      return this.curSearchType === 'name'
        ? this.$store.getters.getProductListByName(this.searchVal)
        : this.$store.getters.getProductListByPrice(this.searchVal);
    }
  },
  methods: {
    selectProduct(
      productId,
      cpProductId,
      remark,
      productType,
      empty = false,
      isCurrency
    ) {
      if (empty) {
        return;
      }
      const serverId = this.$store.state.serverId;
      const roleId = this.$store.state.roleId;
      const roleInfo = this.$store.state.roleList;
      const serverInfo = this.$store.state.serverList;
      if (!serverId || !roleId) {
        alert(this.letter.seletGameInfoFirst);
        return;
      }
      // 搜索打点
      this.searchVal.length &&
        commonEmitUpload(
          `search-product-by-${this.curSearchType}`,
          {
            event: `search-product-by-${this.curSearchType}`,
            newPage: true,
            pageName: 'select-product-page',
            type: 'click'
          },
          this.searchVal
        );
      let roleName = '';
      let sId = '';
      for (let i = 0; i < roleInfo.length; i++) {
        if (parseInt(roleInfo[i].roleID, 10) === parseInt(roleId, 10)) {
          roleName = roleInfo[i].roleName || '';
          break;
        }
      }
      for (let i = 0; i < serverInfo.length; i++) {
        if (serverInfo[i].ID === serverId) {
          sId = serverInfo[i].SID || '';
          break;
        }
      }
      let storeUrl =
        process.env.NODE_ENV === 'production'
          ? `//pay.${mainHost}/platform/store.html`
          : `//pay.${mainHost}/store.html`;
      if (this.uidGame) {
        storeUrl = `//${window.location.host}/platform/store.html`;
      }

      // 2024-09-24:把所有链接参数上报给submit接口，由后端透传(这里是把webstore的页面参数传到实际提单的store页面)
      let hrefParams = globalConfig.getAllUrlParamsObj();
      let paramsObj = {
        ...hrefParams,
        gameId: this.$store.state.gameId,
        serverId: sId,
        roleId,
        roleName: encodeURIComponent(roleName),
        productId,
        cpProductId,
        remark: remark,
        loginAccount: this.$store.state.userName,
        userId: this.$store.state.userId,
        web: 1,
        language: this.$store.state.lang,
        fromIframe: isFromIframe,
        pageSource,
        productType,
        isCurrency: +!!isCurrency,
        cid: globalConfig.getHrefParam('cid'),
        scid: globalConfig.getHrefParam('scid'),
        packageName: globalConfig.getHrefParam('packageName'),
        hideService: globalConfig.getHrefParam('hideService'),
        mode: globalConfig.getHrefParam('mode'),
        ...getGlobalGetLinkParams()
      };

      let curStoreUrl = '';
      let paramsStrArr = [];

      Object.keys(paramsObj).forEach(key => {
        paramsStrArr.push(`${key}=${paramsObj[key]}`);
      });

      try {
        let _curStoreUrl = new URL(`${storeUrl}#/web`);
        Object.keys(paramsObj).forEach(key => {
          _curStoreUrl.searchParams.append(key, paramsObj[key]);
        });
        curStoreUrl = _curStoreUrl.href;
      } catch (error) {
        curStoreUrl = `${storeUrl}?${paramsStrArr.join('&')}#/web`;
      }

      window.location.href = curStoreUrl;
      // 保存跳到储值页前的链接，为了返回时能获取跳过去前的信息
      sessionStorage.setItem(
        'forwardLinksParam',
        `?${paramsStrArr.join('&')}#/web`
      );
    },
    updateOrderType(value) {
      this.curOrderType = value;
    },
    updateProductType(value) {
      this.curProductType = value;
    },
    getProductDefaultIcon(type) {
      return getProductDefaultImg(type);
    }
    // checkInActiveCoupon(productId, cpProductId) {
    //   let length = this.activeCouponProductList.length;
    //   for(let i = 0;i<length;i++){
    //     if(productId == this.activeCouponProductList[i].PRODUCT_ID && cpProductId == this.activeCouponProductList[i].CP_PRODUCT_ID) {
    //       return true
    //     }
    //   }
    //   return false
    // }
  }
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/webStore.scss';

@keyframes loading {
  from {
    transform: scale(1);
    opacity: 1;
  }
  to {
    transform: scale(0.5);
    opacity: 0.4;
  }
}
.load {
  padding-top: 5vh;
  text-align: center;
  .loading {
    width: 16px;
    height: 50px;
    background: #a2c1ff;
    border: 2px solid #3d5c98;
    display: inline-block;
    margin: auto 2px;
    animation: loading 1s infinite;
  }
  .load2 {
    animation-delay: 0.1s;
  }
  .load3 {
    animation-delay: 0.2s;
  }
}
.choose-product-title {
  color: $font;
  margin-bottom: 0;
  font-size: 2.3vh;
  font-family: 'SourceHanSansSC Bold';
}

.game-box {
  overflow: hidden;
  display: flex;
  justify-content: space-between;
}

.product-item {
  flex: 1;
  border: 2px solid #ddd;
  text-align: center;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 0 0.4vh 1.6vh;
  position: relative;
  overflow: hidden;
  cursor: auto;
  &:hover {
    cursor: pointer;
    border-color: $green;
  }
  &:first-child {
    margin-left: 0;
  }
  &:last-child {
    margin-right: 0;
  }
  .product-icon {
    height: 8.5vh;
    width: 11.5vh;
    margin: 2vh auto 0;
  }
  .product-name {
    /*!rtl:ignore*/
    direction: ltr;
    padding: 1vh;
    font-size: 1.8vh;
    color: #666;
    vertical-align: middle;
    width: 16vh;
    text-align: center;
    margin: auto;
  }

  .coupon-tag {
    background-color: #fff;
    padding-left: 1.1vh;
    text-align: left;
    padding-top: 1vh;
    &-text {
      display: inline-block;
      font-size: 1.2vh;
      border-radius: 0.2vh;
      border: solid 0.1vh #de6262;
      color: #de6262;
      padding: 0.1vh 0.2vh;
    }
  }

  .product-price {
    $w: 5.4vh;
    width: 100%;
    background: white;
    line-height: $w;
    height: $w;
    color: #666;
    .bi {
      font-size: 1.8vh;
      font-weight: 800;
    }
    .price {
      font-size: 2.4vh;
      font-weight: 800;
      &.s {
        font-size: 1.8vh;
      }
    }
  }
  &.currency {
    border-color: #fdf4bd !important;
    .product-price {
      background: #fdf4bd !important;
      color: #ffa200 !important;
    }
  }
}

@mixin before($color) {
  content: '';
  position: absolute;
  width: 0;
  height: 0;
  border-style: solid;
  border-left-width: 0;
  border-top-width: 5px;
  border-bottom-width: 5px;
  border-right-width: 10px;
  border-color: transparent;
  border-right-color: $color;
}

.product-tag {
  position: absolute;
  top: 2vh;
  left: 0;
  color: #fff;
  background: #f65353;
  padding: 0.2vh 0.6vh;
  max-width: 18.1vw;
  font-size: 1.4vh;
}
.uid-tips {
  color: #f65353;
  font-size: 1.6vh;
  margin: -1vh auto 2vh 0;
  word-break: break-word;
}
.search-wrap {
  width: 100%;
  height: 6vh;
  display: flex;
  justify-content: left;
}
.search-tips {
  color: #f65353;
  font-size: 1.6vh;
  margin: 1vh auto 2vh 0;
  word-break: break-word;
}
.search-input {
  outline: none;
  width: 100%;
  box-sizing: border-box;
  display: inline-block;
  height: 4.5vh;
  border-radius: 0;
  padding: 0 2vh;
  background: #fff;
  color: #666;
  border: 1px solid rgb(169, 169, 169);
  margin-top: 1.7vh;
  margin-left: 0.5vh;
  font-size: 1.8vh;
  &::-webkit-search-cancel-button {
    display: none;
  }
}
.select-product-order,
.select-search-type {
  top: 0 !important;
  right: 0;
  position: relative;
  font-size: 1.8vh;
  height: 4.2vh;
  padding: 0 2vh;
  border-color: rgb(169, 169, 169);
  background: white;
  margin: 1.7vh auto 1.7vh;
}

.product-type-select {
  display: flex;
  margin: 0 auto 1.7vh;
  &-item {
    flex-grow: 1;
    font-size: 2vh;
    line-height: 4.2vh;
    height: 4.2vh;
    border: 1px solid rgb(169, 169, 169);
    text-align: center;
    margin-right: 1vh;
    cursor: auto;
    &:hover {
      cursor: pointer;
    }
    &:last-child {
      margin-right: 0;
    }
    &.cur {
      background-color: $green;
      color: white;
      border-color: $green;
    }
  }
}

.not-select {
  border: none;
  .product-icon,
  .product-price {
    display: none;
  }
}

.swtwt-tip {
  width: 80vw;
  font-size: 1.4vh;
  margin-bottom: 1.7vh;
  p {
    margin: 0;
  }
}
@media screen and (orientation: landscape) {
  .swtwt-tip {
    width: 50vw;
  }
}
</style>
